module.exports = {
  'page.user.login.form-item-username': 'Tên người dùng',
  'page.user.login.form-item-username.required':
    'Vui lòng nhập tên người dùng của bạn',
  'page.user.login.form-item-email': 'Email',
  'page.user.login.form.remember-me': 'Ghi nhớ',
  'page.user.login.form-item-password': 'Mật khẩu',
  'page.user.login.form-item-password.required':
    'Vui lòng nhập mật khẩu của bạn',
  'page.user.login.form.title': 'Đăng nhập tài khoản',
  'page.user.login.form.btn-submit': 'Đăng nhập',
  'page.user.login.form.btn-jump': 'Hoặc Đăng ký ngay bây giờ?',
  'page.user.login.form.login-error':
    'Tên người dùng hoặc mật khẩu không đúng!',

  'page.user.login.form.login-success': 'Đăng nhập thành công!',

  'page.user.register.form.btn-submit': 'Đăng ký',
  'page.user.register.form.btn-cancel': 'Huỷ',
  'page.user.register.form.register-successfully': 'Đăng ký thành công!',

  'page.user.register.form.register-error': 'Đăng ký không thành công!',

  'page.user.login.error.USER_ERROR_INCORRECT_USERNAME_OR_PASSWORD':
    'Sai tên tài khoản hoặc mật khẩu',
  'page.user.login.error.USER_ERROR_UNACTIVATED':
    'Tài khoản chưa được kích hoạt!',

  'page.user.changePassword.success': 'Đổi mật khẩu thành công!',
  'page.user.changePassword.error': 'Đổi mật khẩu không thành công!',
  'page.user.changePassword.form-item-password.required':
    'Vui lòng nhập mật khẩu mới!',
  'page.user.changePassword.form-item-password.mismatch':
    'Mật khẩu không khớp!',
  'page.user.register.form-item-password.required': 'Vui lòng nhập mật khẩu!',
  'page.user.register.form-item-password.min':
    'Mật khẩu phải chứa ít nhất 12 ký tự!',
  'page.user.register.form-item-password.pattern-rule':
    'Mật khẩu phải chứa ít nhất 3 nhóm ký tự: chữ hoa (A-Z), chữ thường (a-z), số (0-9), và ký tự đặc biệt.',
  'page.user.register.form-item-username.required':
    'Vui lòng nhập tên người dùng!',
  'page.user.register.form-item-email.required': 'Vui lòng nhập email!',
  'page.user.register.form-item-email.invalid': 'Vui lòng nhập email hợp lệ!',
  'page.user.changePassword.success.redirect':
    'Đổi mật khẩu thành công, sẽ đăng xuất sau 3 giây',
  'page.user.register.form-item-password.username-rule':
    'Mật khẩu không được chứa tên người dùng!',
  'page.user.register.title': 'Tạo tài khoản mới',
  'page.user.currentPassword': 'Mật khẩu hiện tại',
  'page.user.newPassword': 'Mật khẩu mới',
  'page.user.confirmPassword': 'Xác nhận mật khẩu',
  'page.user.changePassword.samePassword': 'Mật khẩu không khớp!',
  'page.user.login.form-item-access-token': 'Access Token',
  'page.user.login.form-item-access-token.required':
    'Vui lòng nhập access token của bạn',
};
